//@flow
import React from 'react';
import { Box, Text, Button as NeoButton } from '@locus-taxy/neo-ui';
import TooltipContent, {
    TooltipHeader,
    TooltipBody,
    TooltipItem,
    TooltipSection
} from 'common/components/common/TooltipContent';
import { neoUIColors } from 'common/enums/ColorEnum';

class FpPlanEditTooltip extends React.PureComponent {
    render() {
        const { salesbeatPlan, showEditsDialog, t } = this.props;
        const { editsSummary, assignedVisitCount } = salesbeatPlan.summary;
        const { unallocatedVisitIds } = salesbeatPlan;
        return (
            <TooltipContent minWidth={240}>
                <TooltipHeader
                    value={
                        <Box mb={1} mt={2}>
                            <Text fontSize={2} fontWeight={600}>
                                {t('fpPlanView.planEdits')}
                            </Text>
                        </Box>
                    }
                />
                <TooltipBody>
                    <TooltipSection>
                        <TooltipItem>
                            <TooltipItem.Title
                                value={
                                    <Text fontSize={0}>
                                        {t('fpPlanView.allocated')}
                                    </Text>
                                }
                            />
                            <TooltipItem.Value
                                value={
                                    <Text fontSize={1} fontWeight="medium">
                                        {assignedVisitCount}{' '}
                                        {t('fpPlanView.visit')}
                                    </Text>
                                }
                            />
                        </TooltipItem>
                        <TooltipItem>
                            <TooltipItem.Title
                                value={
                                    <Text fontSize={0}>
                                        {t('fpPlanView.unallocated')}
                                    </Text>
                                }
                            />
                            <TooltipItem.Value
                                value={
                                    <Text fontSize={1} fontWeight="medium">
                                        {`${unallocatedVisitIds.length}
                                        ${t('fpPlanView.visit')}`}
                                    </Text>
                                }
                            />
                        </TooltipItem>

                        <TooltipItem>
                            <TooltipItem.Title
                                value={
                                    <Text fontSize={0}>
                                        {t('fpPlanView.moved')}
                                    </Text>
                                }
                            />
                            <TooltipItem.Value
                                value={
                                    <Text fontSize={1} fontWeight="medium">
                                        {`${editsSummary?.editCounts.MOVE || 0}
                                        ${t('fpPlanView.visit')}`}
                                    </Text>
                                }
                            />
                        </TooltipItem>
                    </TooltipSection>
                    <TooltipSection>
                        <TooltipItem>
                            <NeoButton
                                icon="dispatcher_plan_edited"
                                size="medium"
                                onClick={showEditsDialog}
                                palete="primary"
                                appearance="solid"
                                color={neoUIColors.blue500}
                            >
                                {t('fpPlanView.showEdits')}
                            </NeoButton>
                        </TooltipItem>
                    </TooltipSection>
                </TooltipBody>
            </TooltipContent>
        );
    }
}

export default FpPlanEditTooltip;
